export const REDUX_STORAGE_KEY = '__REDUX_STORAGE';
export const CAN_USE_DOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

export const SHARE_CONSTANTS = {
  X: 'x',
  FACEBOOK: 'facebook',
  MAIL: 'e-mail',
  WHATS_APP: 'whatsapp',
} as const;

const DAY = 60 * 60 * 24;
const MINUTE = 60 * 1;
const CACHE_VALUE = process.env.ENV === 'production' ? 1 * DAY : 10 * MINUTE;
export const CACHE_CONTROL_HEADER = `public, max-age=${CACHE_VALUE}, s-maxage=${CACHE_VALUE}`;

export const VARY_HEADER = 'origin, accept-encoding';

export const ALLOWED_QUERIES = ['d'];

export const OG = {
  mainPage: {
    title: `תראו כמה זמן מחייכם עברו במלחמות!`,
    description: `היכנסו ותגלו כמה מלחמות ומבצעים התרחשו במהלך חייכם`,
  },
  resultsPage: {
    title: (percentage: number) => `${percentage}% מחיי עברו בזמן מלחמה!`,
    description: `ומה איתכם? היכנסו וגלו כמה מלחמות ומבצעים התרחשו במהלך חייכם`,
  },
};
